<template>
  <div class="page-wrapper">
    <div class="page-content-wrapper">
      <div class="shadow-btm">
        <div class="row">
          <div
            class="col-lg-12 col-sm-12 my-auto d-flex align-items-center mb-4"
          >
            <a
              class="pr-2 text-dark cursor-pointer"
              v-on:click="$router.push('/dropdown-menu')"
              ><span class="font-24 mr-2"
                ><img src="/images/back-arrow.svg" width="18"
              /></span>
            </a>
            <h4 class="mb-0 lg-bld">Relation</h4>
          </div>
        </div>
      </div>
      <div
        class="page-content"
        v-show="accessObject?.is_view == 1 || !isShowAccessDeniedMessage"
      >
        <div class="card-body py-0 px-2">
          <ul class="nav nav-pills">
            <li class="nav-item cursor-pointer">
              <a
                class="nav-link"
                data-toggle="tab"
                v-on:click="$router.push('/dropdown-menu')"
              >
                <span> Education Group</span></a
              >
            </li>
            <li class="nav-item cursor-pointer">
              <a
                class="nav-link"
                data-toggle="tab"
                v-on:click="$router.push('/body-structure')"
              >
                <span>Body Structure</span></a
              >
            </li>

            <li class="nav-item cursor-pointer">
              <a
                class="nav-link"
                data-toggle="tab"
                v-on:click="$router.push('/personality')"
              >
                <span>Personality</span></a
              >
            </li>
            <li class="nav-item cursor-pointer">
              <a
                class="nav-link"
                data-toggle="tab"
                v-on:click="$router.push('/diet')"
              >
                <span>Diet</span></a
              >
            </li>
            <li class="nav-item cursor-pointer">
              <a
                class="nav-link"
                data-toggle="tab"
                v-on:click="$router.push('/skin-tone')"
              >
                <span>Skin Tone</span></a
              >
            </li>
            <li class="nav-item cursor-pointer">
              <a
                class="nav-link"
                data-toggle="tab"
                v-on:click="$router.push('/occupation')"
              >
                <span>Occupation</span></a
              >
            </li>
            <li class="nav-item cursor-pointer">
              <a
                class="nav-link"
                data-toggle="tab"
                :class="{ active: currentTab == 'RELATION' }"
                v-on:click="changeTab('RELATION')"
              >
                <span>Relations</span></a
              >
            </li>
             <li class="nav-item cursor-pointer">
              <a
                class="nav-link"
                data-toggle="tab"
                v-on:click="$router.push('/marital-status')"
              >
                <span>Marital Status</span></a
              >
            </li>
            <li class="nav-item cursor-pointer">
              <a
                class="nav-link"
                data-toggle="tab"
                v-on:click="$router.push('/devak')"
              >
                <span>Devak</span></a
              >
            </li>
            <li class="nav-item cursor-pointer">
              <a
                class="nav-link"
                data-toggle="tab"
                v-on:click="$router.push('/es')">
                <span>Eco Status</span></a
              >
            </li>
          </ul>
          <div class="row mt-3">
            <div class="col-lg-6 col-sm-6 form-group row">
              <div class="has-search ml-3">
                <i
                  class="fa fa-search"
                  style="position: absolute; margin: 10px"
                  aria-hidden="true"
                ></i>
                <input
                  type="text"
                  class="form-control"
                  v-on:keyup.enter="getList(0)"
                  placeholder="Search"
                  v-model="searchObj.keyword"
                />
              </div>
              <a
                class="fill-btn btn-style cursor-pointer ml-3"
                v-on:click="getList(0)"
                >Search</a
              >
              <a
                class="fill-btn btn-style cursor-pointer"
                v-on:click="resetFilter"
                v-show="searchObj.keyword"
                >Reset</a
              >
            </div>
            <div
              style="cursor: pointer"
              class="col-lg-6 col-sm-6 txt-right form-group"
            >
              <a
                v-show="accessObject?.is_add == 1"
                class="fill-btn cursor-pointer"
                
                v-on:click="showRelationPopup()"
                >+ Add</a
              >
            </div>
          </div>
          <div class="card border mb-0 radius-15">
            <div class="card-body p-0 pb-4">
              <div class="table-responsive">
                <div class="dataTables_wrapper dt-bootstrap4">
                  <table
                    class="table table-striped table-bordered dataTable"
                    style="width: 100%"
                    role="grid"
                    aria-describedby="example_info"
                  >
                    <thead>
                      <tr role="row">
                        <th>Sr. No.</th>
                        <th
                          class="sorting"
                          id="id-name"
                          v-on:click="sorting('name', 'id-name')"
                        >
                          Relations Name
                        </th>
                        <th>Color</th>
                        <th  v-show="
                              accessObject?.is_edit == 1 ||
                              accessObject?.is_delete == 1
                            ">Action</th>
                      </tr>
                    </thead>
                    <tbody v-show="!loader">
                      <tr v-for="(data, index) in list" :key="index">
                        <td style="text-align: left">{{ index + 1 }}</td>
                        <td style="text-align: left">{{ data.name }}</td>
                        <td
                          :style="
                            data.color_code
                              ? 'background-color:' + data.color_code
                              : ''
                          "
                        >
                        </td>
                        <td  v-show="
                              accessObject?.is_edit == 1 ||
                              accessObject?.is_delete == 1
                            ">
                          <a
                            v-show="accessObject?.is_edit == 1"
                            class="fill-btn btn-style cursor-pointer"
                            v-on:click="showUpdateRelationPopup(index)"
                            >Edit</a
                          >
                          <a
                            v-show="accessObject?.is_delete == 1"
                            class="fill-btn btn-style cursor-pointer"
                            v-on:click="showDeletePopup(data)"
                            >Delete</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row mx-0 mb-4">
                <div class="col-lg-12 mt-5 text-center">
                  <div class="page-bottom-pagination text-right">
                    <Pagination
                      @page-change="pageChange"
                      @items-per-page-change="itemsPerPageChange"
                      ref="listPagination"
                    />
                  </div>
                </div>
              </div>
              <ErrorComponent @retry="getList(0)" ref="errorComponent" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <TextModal ref="textModal">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ detail.uuid ? "Edit" : "Add" }} Relations
        </h5>
        <button
          type="button"
          class="close"
          v-on:click="$refs.textModal.closeModal"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <Form ref="relationForm" @submit="save">
        <div class="modal-body">
          <div class="">
            <div class="form-group">
              <label>Relation Name</label>
              <span class="text-danger">*</span>
              <Field
                type="text"
                class="form-control"
                name="relation"
                placeholder="Relation Name"
                rules="required:relation"
                :validateOnInput="true"
                v-model="detail.name"
              />
              <ErrorMessage name="relation" class="text-danger" />
            </div>
          </div>
          <div class="">
            <Field
              type="color"
              class="form-control"
              name="color"
              placeholder="Select Color"
              v-model="detail.color_code"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button class="fill-btn" id="save-button">Save</button>
          <button
            type="button"
            class="fil-btn"
            id="cancel-button"
            v-on:click="$refs.textModal.closeModal"
          >
            Cancel
          </button>
        </div>
      </Form>
    </TextModal>
    <div
      class="text-center"
      style="margin-top: 20%"
      v-show="accessObject?.is_view == 0 || isShowAccessDeniedMessage"
    >
      <h3>You do not have access to view dropdown menu</h3>
    </div>
  </div>
  <DeleteModal @remove="deleteRecord($event)" ref="deleteModal" />
</template>
<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import TextModal from "@/components/TextModal";
import DeleteModal from "@/components/DeleteModal";
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
// import { ColorPicker } from "vue3-colorpicker";
// import "vue3-colorpicker/style.css";
export default {
  name: "Relations",
  components: {
    ErrorComponent,
    Pagination,
    TextModal,
    DeleteModal,
    Form,
    Field,
    ErrorMessage,
    // ColorPicker,
  },
  data() {
    return {
      accessObject: this.$helperService.getAccessLevel("Manage Dropdown Menu"),
      isShowAccessDeniedMessage: false,
      uuid: this.$route.params.uuid,
      currentTab: "RELATION",
      loader: true,
      searchObj: {
        keyword: "",
        type: "RELATION",
      },
      offset: -1,
      list: [],
      detail: {
        uuid: "",
        name: "",
        type: "RELATION",
        color_code: "",
      },
    };
  },
  mounted() {
    this.$helperService.showMenu("true");
    this.getList(0);
    this.changeTab("RELATION");
  },
  methods: {
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(page, orderBy, sortBy) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.$api
        .getAPI({
          _action: "/master-data/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No Relations Available");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    save() {
      if (this.detail.uuid) {
        this.$api
          .putAPI({
            _action: "/master-data",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then(() => {
            // this.$router.go(-1);
            this.$refs.textModal.closeModal();
            this.$notify({
              type: "success",
              text: "Relation updated successfully",
            });
            this.getList(0);
          })
          .catch(() => {});
      } else {
        this.$api
          .postAPI({
            _action: "/master-data",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then(() => {
            // this.$router.go(-1);
            this.$refs.textModal.closeModal();
            this.$notify({
              type: "success",
              text: "Relation added successfully",
            });
            this.getList(0);
          })
          .catch(() => {});
      }
    },
    showRelationPopup() {
      this.detail.uuid = "";
      this.$refs.textModal.showModal();
      this.$refs.relationForm.resetForm();
    },
    showUpdateRelationPopup(index) {
      this.detail = {};
      this.detail.name = this.list[index].name;
      this.detail.uuid = this.list[index].uuid;
      this.detail.color_code = this.list[index].color_code;
      this.detail.type = "RELATION";
      this.$refs.textModal.showModal();
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj.keyword = "";
      this.getList(0);
    },
    showDeletePopup(data) {
      this.$refs.deleteModal.showModal(
        "Delete Relation",
        "Are you sure you want to delete " + data.name,
        data
      );
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      this.$api
        .putAPI({
          _action: "/master-data/delete/" + detail.uuid,
        })
        .then((res) => {
          if (res) {
            this.$refs.deleteModal.closeModal();
            this.getList(0);
            this.$notify({
              type: "success",
              text: "Relation deleted successfully",
            });
          }
        })
        .catch(() => {
          this.$refs.deleteModal.removeLoader();
        });
    },
    changeTab(tab) {
      this.currentTab = tab;
      if (tab == "RELATION") {
        this.$router.push("/relation");
      }
    },
  },
};
</script>
